import { Slider, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

const RangeSlider = ({ setPrice, price, api}) => {

    const { t, i18n } = useTranslation(['translation']);

    const [value, setValue] = useState([0, price]);

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleCommitted = () => {
        setPrice(value);
    };

    useEffect(() => {
        setValue([0, price]);
        setPrice([0, price])
    }, [price])

    return (
        <Box sx={{ width: {xs:270, lg:300} }} paddingTop='20px' className='visidea-visualsearch__filter-price'>
            <Slider
                value={value}
                valueLabelDisplay="auto"
                step={1}
                min={0}
                max={price}
                onChangeCommitted={() => handleCommitted()}
                onChange={(event) => handleChange(event)}
                sx={{
                    color: '#1D252D',
                    borderColor: '#1D252D',
                    '&:hover': {
                        borderColor: '#1D252D',
                        color: '#1D252D',
                    }
                }}
            />
            <Box display='flex' justifyContent='space-between' paddingTop='5px'>
                <Typography>{t('From')} {api.format_currency(value[0])}</Typography>
                <Typography>{t('To')} {api.format_currency(value[1])}</Typography>
            </Box>
        </Box>
    )
}

export default RangeSlider